<app-table
        [data]="valueStreams"
        [config]="tableConfig"
        title="{{ 'admin.valueStreams.table.title' | translate }}"
        [rowExpand]="false"
        [rowDuplicate]="true"
        [isMaterial]="false"
        [isLoading]="isLoading"
        [hasTitle]="false"
        [showFilters]="true"
        [headerBackgroundColor]="headerBackgroundColor"
        (sortChange)="onSortChange($event)"
        (filterChange)="onFilterChange($event)"
        (pageChange)="onPageChange($event)"
        (duplicateClick)="onDuplicate($event)"
        (rowClick)="onRowClick($event)"
>
    <app-table-column
            header="{{ 'admin.valueStreams.table.columns.valueStream' | translate }}"
            filter="true"
            filterPlaceholder="{{ 'admin.valueStreams.table.filter.placeholder.valueStream' | translate }}"
            sortable="true"
            field="valueStreamName">
    </app-table-column>

    <app-table-column
            header="{{ 'admin.valueStreams.table.columns.email' | translate }}"
            filter="true"
            filterPlaceholder="{{ 'admin.valueStreams.table.filter.placeholder.email' | translate }}"
            sortable="true"
            field="emailAddress">
    </app-table-column>

</app-table>
